import { Component, HostListener } from '@angular/core';
import { AppConfigService } from '@madeinlune/ngx-app-config';
import { ZonelessRouting } from './zone-less/zone-less-routing.service';
import { IdleMonitorService } from '@scullyio/ng-lib';

@Component({
  selector: 'i2l-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private appConfigService: AppConfigService,
    private zonelessRouting: ZonelessRouting,
    private idleMonitorService: IdleMonitorService
  ) {
    this.zonelessRouting.init();
    this.idleMonitorService.setPupeteerTimeoutValue(60000);
  }

  @HostListener('document:keyup', ['$event.ctrlKey', '$event.key'])
  onKeyUp(ctrlKey: boolean, key: string): void {
    if (ctrlKey && key === 'E') {
      this.appConfigService.showAppConfigSwitcher();
    }
  }
}
